export { default } from './PartnerPage'
